import { AuthConfig } from '@auth0/auth0-angular';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { Action } from '@ngrx/store';
import { LocationsRefreshActions } from '../app/components/locations-skeleton/location-list/state/location-list-actions';
import { GlobalState } from '../app/store/global';
import { BASE_AUTH_CONFIG } from './environment.prod';

export const environment = {
  production: false,
  staging: true,
  providers: [
      provideStoreDevtools({
        connectInZone: true,
        maxAge: 25, // Retains last 25 states
        autoPause: true, // Pauses recording actions and state changes when the extension window is not open
        // UI / DEV tools get sluggish (also error logs) at a certain point and since there is no
        // filter / search functionality in dev tools, it's pointless to show even 150 locations
        // https://github.com/reduxjs/redux-devtools-extension/blob/master/docs/Troubleshooting.md#excessive-use-of-memory-and-cpu
        actionSanitizer: (action: Action) => action.type === LocationsRefreshActions.getEntireLocationListSuccess.type &&
        action['locations']?.length >= 150 ?
            { ...action, locations: '>=150 locations - too big to show'} : action
        ,
        stateSanitizer: (state: GlobalState) => state?.locations?.locationList?.locations?.ids?.length >= 150 ?
            { ...state, locations: {
                ...state.locations, locationList: {
                  ...state.locations.locationList, locations: '>=150 locations - too big to show'}} } :
            state
      }),
  ],
  activeFeatures: {
    gxWrapped: false,
    campaignsTour: false,
    landingPages: false,
    aiInsightsTour: false,
    reviewTranslationTour: false,
    rebrandingTour: true,
    dev: {
      xhrInterceptionAndLogout: false,
      claimAndCleanMocking: true,
      showGoogleUpdateValueColumn: false,
    },
  },
  // outgoing API requests
  // will be overwritten by build script when running build pipeline
  baseURL: 'https://lsc-be-service-dev-382936927762.europe-west6.run.app',
  // needs to be set manually
  baseAgentUrl: 'https://agentic-service-gateway-4vx2rcia.ew.gateway.dev',
  auth0: {
    // shared config for local dev & prod
    ...BASE_AUTH_CONFIG,

    domain: 'gxperts-dev.eu.auth0.com',
    clientId: '7vrHgzPmTp0b9XmMraDv4vX0nCf12vWS',

    authorizationParams: {
      audience: 'https://gxperts-bls-staging.oa.r.appspot.com/',
    },
  } as AuthConfig,
};
